import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import Janus from "@jd/jzb.jdee-janus";
import { FocusSDK, getWebEnvObj, isFocusEnv } from "@/utils";
import { getAppVersion } from "@/utils/getVersion";
export let janusInstance: Janus;

export function setJanusInstance(appRuntimeEnv: AppRuntimeEnv) {
  janusInstance = new Janus({
    hostAppId: (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID,
    host: appRuntimeEnv.gatewayHost,
    deviceCode: appRuntimeEnv.registryConfig.machineId,
    // appSecretKey: getWebEnvObj().REACT_APP_DESKTOP_SECRETKEY || "",
    appId: appRuntimeEnv.gateway.appId, // getAppId() || '', // janus网关appid
    // @ts-ignore
    stage: appRuntimeEnv.gateway.stage || getWebEnvObj().REACT_APP_JANUS_STAGE,
    appVersion: getAppVersion(FocusSDK),
    // appKey: getWebEnvObj().REACT_APP_DESKTOP_SECRETKEY || "",
    clientType: (!isFocusEnv() && "web") || appRuntimeEnv.registryConfig.client
  });
  console.log(janusInstance, "janusInstance");
}
